import { Injectable, PipeTransform, Pipe } from "@angular/core";
@Pipe({
 name: 'searchfilter'
})
@Injectable()
export class SearchFilterPipe implements PipeTransform {
 transform(items: any[], field: string, value: string): any[] {
   if (!items) return [];
   if (!value) return items;
   return items.filter(it => it[field] == value);
 }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/search-filter.ts